import "../../assets/css/results/map.css"

import { useMemo } from "react"

import testImage from "../../assets/images/popup-img.png"
import close from "../../assets/images/white-close.svg"
import { useAuth } from "../../context/auth-context"
import { addCommas } from "./utils.js"
import { useGeneralStates } from "../../context/general-context.jsx"


export default function CustomPopup(props) {
    const { 
        cityId,
        activePopup,
        closePopUps,
        routeInProgress,
        handleCreateRoute,
        handleStreetView,
        citiesUrlPhotos
    } = props

    const { user } = useAuth()
    const { state } = useGeneralStates()

    const citySelected = useMemo(() => {
        return user.selectedCities.find(city => city._id === cityId)
    }, [cityId])

    const cityImage = useMemo(() => {
        return citiesUrlPhotos.find(cityPhoto => cityPhoto._id === cityId)?.urlPhoto
    }, [cityId, citiesUrlPhotos])

    return (
        <main className={`custom-popup ${activePopup === cityId ? "open" : ""}`} onClick={(e) => e.stopPropagation()}>
            <div className="close-popup">
                <img src={close} onClick={closePopUps}/>
            </div>
            <img className="img" src={cityImage ?? testImage} />
            <div className="header">
                <h4>{citySelected.municipality_name}</h4>
                <p>{citySelected.state_name}</p>
            </div>
            <section className="infoContainer">
                <div className="info">
                    <h4>{addCommas(citySelected.population)}</h4>
                    <p>Population</p>
                </div>
                <div className="info">
                    <h4>{addCommas(citySelected.EAP)}</h4>
                    <p>Economically Active population</p>
                </div>
                <div className="info">
                    <h4 className="teaserDataHide">N/A</h4>
                    <p>Manufacturing companies</p>
                </div>
                <div className="info">
                    <h4>{addCommas(citySelected.distanceToBorder)} km</h4>
                    <p>Distance from border</p>
                </div>
            </section>
            <section className="btnContainer">
                <button 
                    id="streetView" 
                    className="button primary" 
                    onClick={() => handleStreetView(citySelected.datamexico_municipality_id)}
                >
                    <span>Street view</span>
                </button>
                <button
                    id="createRoute" 
                    className="button primary" 
                    disabled={!state.clientLocation || routeInProgress} 
                    onClick={() => handleCreateRoute(citySelected)}
                >
                    <span>Create route</span>
                </button>
            </section>

        </main>
    )
}
